import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-summary-report',
  templateUrl: './summary-report.component.html',
  styleUrls: ['./summary-report.component.scss']
})
export class SummaryReportComponent implements OnInit {
  public summaries:any = [];
  public permission:any = {};
  public is_loading = false;
  public filterMonth: string;
  public is_mario:boolean = false;

  constructor(private http: HttpService) {

    this.permission = this.http.getSelecetdCompanyDetail();

    const now = new Date();
    this.filterMonth = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2);

    this.getData();

    let access:any = this.http.getAccess();

    if(access.is_mario) {
      this.is_mario = access.is_mario == "1" ? true : false;
    }
  }

  ngOnInit(): void {
  }

  monthChange(val:any) {
    this.filterMonth = val.target.value;
    this.getData(val.target.value + "-01");
  }

  async getData(today = null) {

    if(today) {
      console.log("here ka", today)
      today = new Date(today);
    } else {
      today = new Date();
    }

    const curYear = today.getFullYear();
    const curMonth = today.getMonth(); // 0-indexed
    const prevMonth = curMonth === 0 ? 11 : curMonth - 1;
    const prevYear = curMonth === 0 ? curYear - 1 : curYear;

    let months = [
      curYear + "-" + ("0" + (curMonth + 1)).slice(-2),
      prevYear + "-" + ("0" + (prevMonth + 1)).slice(-2)
    ];
    
    this.load(months);
  }

  async save(account) {
    let y:any = await this.http.post("/admin/summary-account/save", account);
  }

  async load(months) {
    this.is_loading = true;
    let y:any = await this.http.post("/admin/summary-account/get", {months});

    if(y.status) {
      this.summaries = y.summaries;
    }
    this.is_loading = false;

  }

  sum(key, arr) {
    let val = arr.map((v:any) => {
      return this.toNumber(v[key])
    })

    return val.reduce((partialSum, a) => partialSum + a, 0);
  }

  toNumber(value) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  capitalAmount(company) {
    const amount = this.toNumber(company.capital) + this.toNumber(company.add_capital) - this.toNumber(company.withdraw_capital);
    return amount > 0 ? amount : 0;
  }

  capitalTotal(companies) {
    return companies.reduce((total, company) => total + this.capitalAmount(company), 0);
  }

  adjustedCapitalBalance(company) {
    return this.toNumber(company.capital_balance) + this.toNumber(company.add_capital) - this.toNumber(company.withdraw_capital);
  }

  update(account) {
    account.cash = this.toNumber(account.capital) + this.toNumber(account.net_profit) - this.toNumber(account.withdraw_capital) + this.toNumber(account.add_capital)
  }

  latestArray() {
    let y = []
    y.push(this.summaries[0])
    console.log(this.summaries, y)
    return y
  }
}
